import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import { hmrBootstrap } from './hmr';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);
console.log("ENV", environment)
if (environment.production) {
    enableProdMode();
    bootstrap();
} else {
    if (module['hot']) {
      hmrBootstrap(module, bootstrap);
    } else {
      bootstrap();
    }
 }
